module.exports = __webpack_public_path__ + "img/blue_143.610a1342.png";